import {
  SAVE_NEXT_VIDEO_ID,
  SAVE_NEXT_AUDIO_ID,
  TOGGLE_NEXT_CALL_VIDEO,
  TOGGLE_NEXT_CALL_AUDIO,
  RESET_CALL_SETTINGS,
  TOGGLE_REMEMBER_SETTINGS,
  SET_NEXT_CALL_OUTPUT
} from 'constants/AvSettingsModal';
import _isUndefined from 'lodash/isUndefined';

const initialState = {
  preserveAvSettings: false,
  rememberSettings: false,
  audio: true,
  video: true
};

const ACTION_HANDLERS = {
  [SAVE_NEXT_VIDEO_ID]: (state, action) => {
    const nextState = Object.assign({}, state);
    nextState.videoSourceId = action.payload;
    return nextState;
  },
  [SAVE_NEXT_AUDIO_ID]: (state, action) => {
    const nextState = Object.assign({}, state);
    nextState.audioSourceId = action.payload;
    return nextState;
  },
  [TOGGLE_NEXT_CALL_VIDEO]: (state) => {
    const nextState = Object.assign({}, state);
    nextState.video = _isUndefined(nextState.video) ? true : !nextState.video;
    return nextState;
  },
  [TOGGLE_NEXT_CALL_AUDIO]: (state, action) => {
    const nextState = Object.assign({}, state);
    nextState.preserveAvSettings = true;
    if (action.payload) {
      nextState.audio = !!action.payload;
    } else {
      nextState.audio = _isUndefined(nextState.audio) ? true : !nextState.audio;
    }
    return nextState;
  },
  [SET_NEXT_CALL_OUTPUT]: (state, action) => {
    const nextState = Object.assign({}, state);
    nextState.audioOutputId = action.payload;
    return nextState;
  },
  [TOGGLE_REMEMBER_SETTINGS]: (state) => {
    const nextState = Object.assign({}, state);
    nextState.rememberSettings = !nextState.rememberSettings;
    return nextState;
  },
  [RESET_CALL_SETTINGS]: () => (initialState)
};

export default function AvSettingsModalReducer(state = initialState, action = {}) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
